<form [formGroup]="formGroup">
  <div>
    <div class="mx-5 mt-5">
      <h5>{{ "Choose your Resume template design" | translate }}</h5>

      <p>{{ "You can always change your template later." | translate }}</p>
    </div>
    <div class="row m-0 px-4">
      <div
        class="col-6 col-md-4 col-lg-3 p-0 cv-card"
        [ngClass]="{ pointer: item.isActive }"
        *ngFor="let item of cvTempletes; let i = index"
        (click)="item.isActive && selectCv(item.name!)"
      >
        <div class="selected" *ngIf="selectedName === item.name"></div>
        <img width="100%" [src]="item.image" />
        <p class="paner" *ngIf="!item.isActive">
          {{ "Coming Soon" | translate }}
        </p>
        <input *ngIf="selectedName === item.name" type="radio" checked />
      </div>
    </div>
    <div
      class="next-container px-4"
      [ngClass]="{
        'isSelected-next-container': selectedName
      }"
    >
      <button class="border-button m-3" (click)="onPrevious()">
        {{ "Back" | translate }}
      </button>
      <button
        class="gradient-button m-3"
        (click)="this.formGroup.get('cvTempleteFile')?.valid && onNext()"
      >
        {{ "Next" | translate }}
      </button>
    </div>
  </div>
</form>
